import ArchiveStructure from "../../Constants/ArchiveStructure";

const fetchArchiveData = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountArchiveContentMockapi.json");
    const data = await response.json();

    // Merge with ArchiveStructure (root is an object, not array)
    const archive = {
      ...ArchiveStructure,
      ...data,
      profiles: (data.profiles ?? []).map((profile) => ({
        ...ArchiveStructure.profiles[0],
        ...profile,
        posts: (profile.posts ?? []).map((post) => ({
          ...ArchiveStructure.profiles[0].posts[0],
          ...post,
          medias: (post.medias ?? []).map((media) => ({
            ...ArchiveStructure.profiles[0].posts[0].medias[0],
            ...media,
            likes: media.likes ?? [],
            comments: media.comments ?? [],
            shares: media.shares ?? [],
            suggests: media.suggests ?? [],
          })),
          likes: post.likes ?? [],
          comments: post.comments ?? [],
          shares: post.shares ?? [],
          suggests: post.suggests ?? [],
        })),
      })),
    };

    return archive;
  } catch (error) {
    console.error("Error fetching archive data:", error);
    return null;
  }
};

export default fetchArchiveData;
